import { createContext, useReducer } from "react";

const INITAL_STATE = {
  from: undefined,
  to: undefined,
  transportation: undefined,
  loadingDate: undefined,
  productType: undefined,
  truckType: undefined,
  volume: undefined,
  weights: undefined,
  equipments: undefined,
};

export const SearchContext = createContext(INITAL_STATE);
const SearchReducer = (state, action) => {
  switch (action.type) {
    case "NEW_SEARCH":
      return action.payload;
    case "RESET_SEARCH":
      return INITAL_STATE;
    default:
      return state;
  }
};

export const SearchContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(SearchReducer, INITAL_STATE);
  return (
    <SearchContext.Provider
      value={{
        from: state.from,
        to: state.to,
        transportation: state.transportation,
        loadingDate: state.loadingDate,
        productType: state.productType,
        truckType: state.truckType,
        volume: state.volume,
        weights: state.weights,
        equipments: state.equipments,
        dispatch,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
